import { render, staticRenderFns } from "./FontsMultiselect.vue?vue&type=template&id=11fcb84d&"
import script from "./FontsMultiselect.vue?vue&type=script&lang=js&"
export * from "./FontsMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports